import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
`;

export const SideNavContainer = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: auto;
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SearchContainer = styled.div<{ $showMobileNav?: boolean }>`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: 16px;
  margin-right: ${({ $showMobileNav }) => ($showMobileNav ? '0px' : '90px')};
  margin-top: 35px;
  max-width: 1200px;
  width: ${({ $showMobileNav }) => ($showMobileNav ? '100%' : 'auto')};
`;
